<template>
  <panel :title="attribute.label" :withBody="false" :withFooter="false" :to="{ name: 'attribute', params: { attributeId: attribute._id.$oid, identifier: identifier } }">
    <div slot="header-right">
      <div class="form-flex">
        <drop>
          <button class="btn" slot="trigger">
            <i class="dropbtn fa fa-ellipsis-v"></i>
          </button>

          <drop-content slot="content" placement="bottom-end">
            <ul class="c-nav c-nav--menus">
              <li class="c-nav__item">
                <a role="button" class="c-nav__link" @click="showModal()">Excluir</a>
              </li>

              <slot/>
            </ul>
          </drop-content>
        </drop>
      </div>

      <modal-delete v-model="modalFlag" :attribute="attribute" v-on:option="remove"/>
    </div>
  </panel>
</template>

<script>
  import { mapActions } from 'vuex'
  import Panel from '@/components/template/Panel'
  import ModalDelete from '@/components/MarketplaceAttribute/ModalDelete'

  export default {
    data: () => ({
      modalFlag: false
    }),
    props: {
      identifier: {
        type: String,
        required: true
      },
      attribute: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions('marketplaceAttribute', [
        'removeAttribute'
      ]),
      showModal () {
        this.modalFlag = true
      },
      remove () {
        this.removeAttribute({ attribute: this.attribute, identifier: this.identifier })
      }
    },
    components: {
      Panel,
      ModalDelete
    }
  }
</script>

<style lang="sass"scoped>
  i
    color: #808080

  .form-flex
    display: inline

  .dropbtn
    margin-left: 10px
    font-size: 24px
    padding: 0

  button.dropbtn
    cursor: pointer

    &[disabled]
      cursor: not-allowed
</style>



// WEBPACK FOOTER //
// AttributeCard.vue?67552ed2